import { useState, useEffect } from "react";
import { fetchEmpresaByTenant } from "../../vinculacion/api/vinculacionApi";

const useTenantOnRoad = (tenant) => {
    const [empresa, setEmpresa] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tenant) {
            setError(new Error('Empresa no encontrada'));
            setLoading(false);
            setEmpresa(null);
            return;
        }

        const loadEmpresa = async () => {
            setLoading(true);
            setError(null);
            
            try {
                const data = await fetchEmpresaByTenant(tenant);
                setEmpresa(data);
            } catch (err) {
                setError(new Error('Empresa no encontrada'));
                setEmpresa(null);
            } finally {
                setLoading(false);
            }
        };

        loadEmpresa();
    }, [tenant]);

    return { empresa, loading, error };
};

export default useTenantOnRoad;